import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseHttpService } from "./base.http.service";
import { PicklistType } from "../enums/picklist-types";
import { Picklist } from "src/app/shared/types/blog-types";

@Injectable({
  providedIn: "root",
})
export class PicklistService extends BaseHttpService {
  constructor(private http: HttpClient) {
    super();
  }

  getPicklistOptions(type: PicklistType) {
    const apiUrl = `${this.apiUrl}/api/picklists/type?delimeter=${type}`;
    return this.http.get<Picklist[]>(apiUrl);
  }

  postPickListOptions(body: unknown) {
    const apiUrl = `${this.apiUrl}/api/Picklists`;
    return this.http.post(apiUrl, body);
  }

  updatePicklistItem(data: unknown, id: number) {
    const apiUrl = `${this.apiUrl}/api/picklists/${id}`;

    return this.http.put(apiUrl, data);
  }

  deletePickListOption(id: number) {
    const apiUrl = `${this.apiUrl}/api/Picklists/deleteCategory/${id}`;
    return this.http.delete(apiUrl);
  }
}
